export const addPathToListPlace = (places, type) => {
  return places.map(place => {
    return addPathToPlace(place, type)
  })
}

export const addPathToPlace = (place, type) => {
  let path = ''
  switch (type) {
    case 'area':
      path = `areas/${place.prefecture_slug}/${place.area_group_slug}/${place.slug}`
      break
    case 'area_group':
      path = `areas/${place.prefecture_slug}/${place.slug}`
      break
    case 'prefecture':
      path = `areas/${place.slug}`
      break
    case 'region':
      path = `regions/${place.slug}`
      break
  }
  return { ...place, path: path }
}
